export const aiToolsInfo = {
  tools: ["ChatGPT", "Gemini", "Claude"],
  display: "ChatGPT · Gemini · Claude",
  sentence: "ChatGPT, Gemini, Claude"
};

export const youthRecruitmentInfo = {
  aiTools: aiToolsInfo,
  period: "온라인 신규 입학 신청: 7/21~7/31 · 온라인 OT: 7/28 · 서울/경기 원데이 부트캠프: 7/30~7/31 (8/1 나니아데이) · 울산 원데이 부트캠프: 8/10~8/12 (8/8 나니아데이)",
  otDescription: "무료 온라인 OT에서 수업 방식과 AI 학습 환경을 먼저 경험해 보세요.",
  otConsultationNote: "무료 OT 이후 상담을 거쳐 월 21만원 정기과정을 신청할 수 있습니다.",
  pricing: {
    regularLabel: "정가",
    regularDisplay: "300,000원",
    regularShort: "30만원",
    promotionLabel: "프로모션 할인가",
    promotionDisplay: "210,000원",
    promotionShort: "21만원",
    billingCycle: "월"
  },
  offers: {
    freeOt: {
      label: "무료 OT",
      priceDisplay: "0원",
      description: "온라인으로 나니아랩 수업과 AI 학습 환경을 체험하는 무료 오리엔테이션"
    },
    regularMembership: {
      label: "정기회원",
      priceDisplay: "월 210,000원",
      regularDisplay: "정가 월 300,000원",
      description: "무료 OT 이후 상담을 거쳐 시작하는 4주 프로젝트 기반 정기과정"
    },
    summerBootcamp: {
      label: "여름 한정 원데이 부트캠프",
      priceDisplay: "회차당 59,000원",
      description: "서울/경기·울산에서 진행하는 3시간 오프라인 집중 이벤트. 정기회원 과정과 별도 상품입니다."
    }
  },
  otCategories: [
    {
      key: "online",
      type: "online",
      label: "실시간 온라인 (Discord)",
      eyebrow: "Online",
      displayName: "온라인",
      icon: "💻",
      color: "#34d399",
      background: "linear-gradient(135deg, rgba(52,211,153,0.1), rgba(52,211,153,0.05))",
      border: "1px solid rgba(52,211,153,0.35)",
      slots: [
        {
          displayName: "신규 입학",
          date: "7월 21일 (화) ~ 31일 (금)",
          dateFull: "2026년 7월 21일 (화) ~ 7월 31일 (금)",
          time: "온라인 접수",
          value: "7월 21일 (화) ~ 7월 31일 (금) 온라인 신규 입학 신청",
          locationShort: "온라인 신청",
          locationFull: "온라인 신규 입학 신청",
          note: "온라인 신규 입학 신청기간",
          limit: 100
        },
        {
          displayName: "온라인 OT",
          date: "7월 28일 (화)",
          dateFull: "2026년 7월 28일 (화)",
          time: "온라인 진행",
          value: "7월 28일 (화) 온라인 OT",
          locationShort: "Discord & 나니아 터미널",
          locationFull: "온라인 (Discord & 나니아 터미널)",
          note: "온라인 오리엔테이션",
          limit: 10
        }
      ]
    },
    {
      key: "gyeonggi",
      type: "offline",
      label: "서울/경기 원데이 부트캠프 & 나니아데이",
      eyebrow: "Seoul / Gyeonggi",
      displayName: "서울/경기",
      icon: "🏙️",
      color: "#00d2ff",
      background: "linear-gradient(135deg, rgba(0,210,255,0.1), rgba(0,210,255,0.05))",
      border: "1px solid rgba(0,210,255,0.35)",
      slots: [
        {
          date: "7월 30일 (목) ~ 31일 (금)",
          dateFull: "2026년 7월 30일 (목) ~ 7월 31일 (금)",
          time: "원데이 부트캠프",
          value: "7월 30일 (목) ~ 7월 31일 (금) 서울/경기 원데이 부트캠프",
          locationShort: "동네소셜라운지(성남시 서현역)",
          locationFull: "동네소셜라운지(성남시 서현역)",
          note: "원데이 부트캠프",
          milestone: {
            label: "나니아데이",
            date: "8월 1일 (토)"
          },
          limit: 20
        }
      ]
    },
    {
      key: "ulsan",
      type: "offline",
      label: "울산 원데이 부트캠프 & 나니아데이",
      eyebrow: "Ulsan",
      displayName: "울산",
      icon: "🗺️",
      color: "#a044ff",
      background: "linear-gradient(135deg, rgba(160,68,255,0.1), rgba(160,68,255,0.05))",
      border: "1px solid rgba(160,68,255,0.35)",
      slots: [
        {
          date: "8월 10일 (월) ~ 12일 (수)",
          dateFull: "2026년 8월 10일 (월) ~ 8월 12일 (수)",
          time: "원데이 부트캠프",
          value: "8월 10일 (월) ~ 8월 12일 (수) 울산 원데이 부트캠프",
          locationShort: "팀솔루션",
          locationFull: "울산 타워더모스트 팀솔루션",
          note: "원데이 부트캠프",
          milestone: {
            label: "나니아데이",
            date: "8월 8일 (토)"
          },
          limit: 20
        }
      ]
    }
  ],
  parentMeeting: {
    eyebrow: "Phone Call",
    title: "학부모 간담회",
    status: "별도 일정 없음",
    summary: "개별 유선상담",
    description: "학부모 간담회는 별도 온라인 일정 없이 개인적인 유선상담으로 진행합니다."
  },
  applicationFlow: [
    {
      title: "무료 OT",
      description: "하루 체험으로 수업 방식과 AI 학습 환경을 먼저 확인합니다."
    },
    {
      title: "등록 상담",
      description: "자녀 성향과 일정에 맞춰 정규 과정 등록을 상담합니다."
    },
    {
      title: "정규 수업",
      description: "4주 동안 AI 도구를 활용해 나만의 프로젝트를 완성합니다."
    }
  ]
};

const getYouthSlot = (categoryKey, index = 0) => (
  youthRecruitmentInfo.otCategories.find((category) => category.key === categoryKey)?.slots[index]
);

export const campsData = [
  {
    id: "lv1_starter",
    title: "Lv.1 AI Starter [청소년 과정]",
    target: "신규 청소년 (초4 ~ 고3)",
    track: "public",
    theme: `${aiToolsInfo.display}를 모두 활용하는 4주 프로젝트 과정`,
    goal: `나니아 터미널 환경에 적응하고, ${aiToolsInfo.sentence}를 활용하여 나만의 첫 번째 웹 프로젝트를 완성합니다.`,
    level: 1,
    description: `무료 온라인 OT 이후 상담을 거쳐 ${aiToolsInfo.sentence}를 모두 활용하는 월 ${youthRecruitmentInfo.pricing.promotionShort} 정기과정에 등록할 수 있습니다. 서울/경기·울산 여름 원데이 부트캠프는 회차당 5만9천원의 별도 한정 이벤트입니다.`,
    period: youthRecruitmentInfo.period,
    location: "온라인 (Discord & 나니아 터미널) + 오프라인(서울/경기·울산)",
    schedules: [
      {
        id: "lv1_online_application",
        name: "온라인 신규 입학 신청기간",
        dates: getYouthSlot("online", 0).dateFull,
        location: getYouthSlot("online", 0).locationFull,
        time: getYouthSlot("online", 0).time
      },
      {
        id: "lv1_online_ot",
        name: "온라인 OT",
        dates: getYouthSlot("online", 1).dateFull,
        location: getYouthSlot("online", 1).locationFull,
        time: getYouthSlot("online", 1).time
      },
      {
        id: "lv1_gyeonggi_bootcamp",
        name: "서울/경기 원데이 부트캠프 & 나니아데이",
        dates: getYouthSlot("gyeonggi", 0).dateFull,
        location: getYouthSlot("gyeonggi", 0).locationFull,
        time: `${getYouthSlot("gyeonggi", 0).milestone.date} ${getYouthSlot("gyeonggi", 0).milestone.label}`
      },
      {
        id: "lv1_ulsan_bootcamp",
        name: "울산 원데이 부트캠프 & 나니아데이",
        dates: getYouthSlot("ulsan", 0).dateFull,
        location: getYouthSlot("ulsan", 0).locationFull,
        time: `${getYouthSlot("ulsan", 0).milestone.date} ${getYouthSlot("ulsan", 0).milestone.label}`
      },
      {
        id: "lv1_parent_meeting",
        name: youthRecruitmentInfo.parentMeeting.title,
        dates: "개별 안내",
        location: youthRecruitmentInfo.parentMeeting.summary,
        time: youthRecruitmentInfo.parentMeeting.description
      }
    ],
    weeklyPrograms: [
      { 
        id: 1, 
        week: "1주차", 
        title: "기획 및 기초 개발",
        subtitle: "아이디어 구체화 및 UI 설계",
        details: [
          `나니아 터미널 및 ${aiToolsInfo.display} 기본 활용법 숙지`,
          "주제에 따른 나만의 아이디어 기획",
          "HTML/CSS를 활용한 웹 서비스 기초 설계"
        ]
      },
      { 
        id: 2, 
        week: "2주차", 
        title: "심화 기능 구현",
        subtitle: "핵심 로직 구현 및 튜터 피드백",
        details: [
          "JavaScript 및 AI API 연동 기능 구현",
          "그룹 미팅을 통한 기술적 문제 해결 및 코칭",
          "중간 점검 및 프로젝트 기능 고도화"
        ]
      },
      { 
        id: 3, 
        week: "3주차", 
        title: "최종 완성 및 최적화",
        subtitle: "피드백 반영 및 배포 준비",
        details: [
          "사용자 피드백 기반 UI/UX 개선",
          "전 세계 어디서나 접속 가능한 실전 배포",
          "발표 자료 제작 및 성과 공유 준비"
        ]
      },
      { 
        id: 4, 
        week: "4주차", 
        title: "나니아 데이 (성과 공유)",
        subtitle: "프로젝트 발표 및 네트워킹",
        details: [
          "온/오프라인 프로젝트 최종 성과 발표",
          "동료들과의 코드 리뷰 및 네트워킹",
          "다음 단계(Lv.2 AI Founder) 진급"
        ]
      }
    ]
  },
  {
    id: "lv2_founder",
    title: "신규 성인반 [1인 CEO 과정]",
    target: "신규 성인 (직장인·프리랜서·예비 창업자)",
    track: "member",
    theme: "하루 오프라인 + 한 달 나니아 서비스 무제한 이용",
    goal: "AI를 내 직원처럼 활용하여 혼자서도 아이디어를 실행하는 1인 CEO 역량을 갖춥니다.",
    level: 2,
    description: "온라인 수업 없이 딱 하루, 오프라인에서 집중적으로 배웁니다. 그리고 한 달간 나니아 서비스를 자유롭게 활용하며 나만의 것을 만들어가세요.",
    period: "2025년 4월 25일 (토) · 오전반 09:00~12:00 / 저녁반 18:00~21:00 택 1 · 1개월 서비스 이용",
    location: "서울 이태원 한국폴리텍대학 (오프라인, 3시간)",
    schedules: [
      {
        id: "lv2_morning",
        name: "오전반",
        dates: "2025년 4월 25일 (토)",
        location: "서울 이태원 한국폴리텍대학",
        time: "09:00 ~ 12:00 (3시간)"
      },
      {
        id: "lv2_evening",
        name: "저녁반",
        dates: "2025년 4월 25일 (토)",
        location: "서울 이태원 한국폴리텍대학",
        time: "18:00 ~ 21:00 (3시간)"
      }
    ],
    weeklyPrograms: [
      {
        id: 1,
        week: "오전: 아이디어 기획",
        title: "나만의 수익 모델 찾기",
        subtitle: "AI로 시장 분석 · 아이디어 구체화",
        details: [
          "AI로 시장 조사 및 아이디어 빠르게 검증하는 법",
          "수익화 가능한 나만의 서비스 컨셉 도출",
          "1인 CEO로서 MVP 범위 설정"
        ]
      },
      {
        id: 2,
        week: "오후: AI 실전 체험",
        title: "나니아 서비스 직접 써보기",
        subtitle: "나니아 터미널 · AI 도구 집중 실습",
        details: [
          "나니아 AI 서버에서 나만의 프로젝트 직접 실행",
          "코딩 없이 AI 도구로 결과물 만들기 체험",
          "마스터 선생님 1:1 즉문즉답 코칭"
        ]
      },
      {
        id: 3,
        week: "이후 1개월: 자유 이용",
        title: "나니아 서비스 무제한 활용",
        subtitle: "혼자서도 계속 만들고 실행하는 환경",
        details: [
          "나니아 AI 서버 1개월 무제한 이용권 제공",
          "카카오 채널을 통한 질문 및 서비스 문의",
          "카카오 채널과 안내 메시지로 수업 알림 · 공지 관리"
        ]
      },
      {
        id: 4,
        week: "마무리: 네트워킹",
        title: "동료 CEO들과 교류",
        subtitle: "성과 공유 및 협업 기회",
        details: [
          "같은 날 참여한 성인반 수강생들과 아이디어 공유",
          "나니아랩 커뮤니티 채널 초대",
          "다음 달 과정 우선 신청 혜택 제공"
        ]
      }
    ]
  }
];
